import { useParams as useNextParams } from 'next/navigation';

export const useParams = <T extends { [K in keyof T]?: string } = {}>() => {
  return useNextParams() as T;
};
